import { InjectionToken } from '@angular/core';

export enum EntityStoreKey {
  DevFlags = 'DevFlags',
}

export type DevFlagsMap = Record<DevFlag, boolean>;
export const DEV_FLAGS = new InjectionToken<DevFlagsMap>('DevFlagsMap');

export enum DevFlag {
  DisableZiggeo = 'disable-ziggeo',
  Referrals = 'referrals', // This flag should be migrated to pricing features after release
  EventDebug = 'debug_event_tracking',
  Hotjar = 'hotjar',
  SharedMailbox = 'shared_mailbox',
  SharedMailboxAutomatedActions = 'shared_mailbox_aa',
  NewTalentPools = 'new_talent_pools',
  RenewalDowngrade = 'renewal_downgrade',
  PP24Enabled = 'pp24_enabled',
  PP24Released = 'pp24_released',
  VonqContracts = 'vonq_contracts',
  AccessToCandidate = 'access_to_candidate',
  TellentAppsDropdown = 'tellent_apps_dropdown',
  ManageLocations = 'manage_locations_flag',
  FeatureSpec = 'new_feature_flags', // I know, but I want to avoid 'NewFeatureFlags' enum key as it's too confusing
  Views = 'views',
}
